import AuthService from '../services/authService';

class AuthGuard {
  private static authPromise: Promise<boolean> | null = null;
  private static isAuthChecked = false;

  static async waitForAuth(): Promise<boolean> {
    // If already checked, return immediately
    if (this.isAuthChecked && AuthService.isAuthenticated()) {
      return true;
    }

    // If auth check is in progress, wait for it
    if (this.authPromise) {
      return this.authPromise;
    }

    // Start auth check
    this.authPromise = new Promise((resolve) => {
      const checkAuth = () => {
        const token = AuthService.getToken();
        if (token) {
          this.isAuthChecked = true;
          resolve(true);
        } else {
          // Check if we're in the middle of authentication
          const urlParams = new URLSearchParams(window.location.search);
          const isAuthenticating = urlParams.has('token') || urlParams.has('magic_token') || 
                                   window.location.pathname.includes('/auth/');
          
          if (isAuthenticating) {
            // We're authenticating, wait a bit and check again
            setTimeout(checkAuth, 100);
          } else {
            // Not authenticating and no token
            this.isAuthChecked = true;
            resolve(false);
          }
        }
      };

      checkAuth();
    });

    const result = await this.authPromise;
    this.authPromise = null;
    return result;
  }

  static reset() {
    this.isAuthChecked = false;
    this.authPromise = null;
  }
}

export default AuthGuard;